import { useT } from "../i18n";

export const LanguageToggle = ({ scrolled = false, variant = "desktop" }) => {
  const { lang, setLang } = useT();
  const isMobile = variant === "mobile";
  const useDark = isMobile || scrolled;

  // pill container styles
  const pillClass = useDark
    ? "bg-[#2A322C]/[0.04] hover:bg-[#2A322C]/[0.07] border border-[#2A322C]/10"
    : "bg-white/10 hover:bg-white/15 border border-white/20 backdrop-blur-sm";

  const activeClass = useDark ? "text-[#2A322C]" : "text-white";
  const inactiveClass = useDark
    ? "text-[#2A322C]/45 hover:text-[#2A322C]/75"
    : "text-white/55 hover:text-white/85";
  const dividerClass = useDark ? "bg-[#2A322C]/20" : "bg-white/30";

  const btnBase =
    "text-[11px] tracking-[0.18em] uppercase transition-all duration-200 px-2 py-[2px] rounded-[6px]";

  return (
    <div
      data-testid="lang-toggle"
      className={`inline-flex items-center gap-1 rounded-full px-2 py-[5px] transition-colors duration-200 ${pillClass}`}
      aria-label="Language toggle"
    >
      <button
        type="button"
        onClick={() => setLang("pt")}
        data-testid="lang-pt"
        aria-pressed={lang === "pt"}
        className={`${btnBase} ${
          lang === "pt" ? `${activeClass} font-bold` : `${inactiveClass} font-medium`
        }`}
      >
        PT
      </button>
      <span aria-hidden className={`inline-block h-3 w-px ${dividerClass}`} />
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="lang-en"
        aria-pressed={lang === "en"}
        className={`${btnBase} ${
          lang === "en" ? `${activeClass} font-bold` : `${inactiveClass} font-medium`
        }`}
      >
        EN
      </button>
    </div>
  );
};
